import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { GraduationCap } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/dashboard", { replace: true });
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const result = await login(email, password);
    setIsLoading(false);
    
    if (result.success) {
      toast.success("Bienvenido a Appadrino");
      navigate("/dashboard");
    } else {
      toast.error(result.error);
    }
  };

  return (
    <div className="min-h-screen bg-brand-lightBlue/30 flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-xl w-full max-w-md p-8 md:p-12">
        <div className="text-center mb-8">
            <Link to="/" className="inline-flex items-center gap-2 mb-6">
                <GraduationCap className="w-8 h-8 text-brand-blue" />
                <span className="text-2xl font-bold text-brand-blue">Appadrino</span>
            </Link>
            <h1 className="text-2xl font-bold text-brand-dark mb-2">Iniciar Sesión</h1>
            <p className="text-gray-500 text-sm">Ingresa para ver el futuro de tus hijos</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
                <Label htmlFor="email">Correo electrónico</Label>
                <Input 
                    id="email" 
                    data-testid="login-email-input"
                    type="email" 
                    placeholder="tucorreo@ejemplo.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="h-12 rounded-xl"
                />
            </div>
            <div className="space-y-2">
                <Label htmlFor="password">Contraseña</Label>
                <Input 
                    id="password" 
                    data-testid="login-password-input"
                    type="password" 
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    className="h-12 rounded-xl"
                />
            </div>
            
            <Button type="submit" data-testid="login-submit-btn" className="w-full h-12 bg-brand-blue hover:bg-brand-blue/90 text-white font-bold rounded-xl text-lg" disabled={isLoading}>
                {isLoading ? "Cargando..." : "Entrar"}
            </Button>
        </form>

        <div className="mt-8 text-center text-sm">
            <p className="text-gray-500">¿No tienes cuenta? <Link to="/register" data-testid="login-register-link" className="text-brand-blue font-bold hover:underline">Regístrate aquí</Link></p>
        </div>
      </div>
    </div>
  );
}
